import { render, staticRenderFns } from "./FirePremium.vue?vue&type=template&id=c1345676&"
import script from "./FirePremium.vue?vue&type=script&lang=js&"
export * from "./FirePremium.vue?vue&type=script&lang=js&"
import style0 from "./FirePremium.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FirePremium.vue"
export default component.exports